import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CircleBook from "../assets/images/circle-book.png";
import CirclePen from "../assets/images/circle-pen.png";
import CircleLang from "../assets/images/circle-lang.png";
import CircleMoon from "../assets/images/circle-moon.png";
import { useTranslation } from "react-i18next";

// Hero slide data
const heroData = [
  {
    key: "feature-premium",
    img: CircleBook,
    alt: "Premium Material",
  },
  {
    key: "feature-illustration",
    img: CirclePen,
    alt: "Illustration",
  },
  {
    key: "feature-dual-language",
    img: CircleLang,
    alt: "Dual Language",
  },
  {
    key: "feature-dawah",
    img: CircleMoon,
    alt: "Dawah",
  },
];

const StoryFeature = () => {
  const { t } = useTranslation();
  return (
    <section className="py-5 storybook-feature" style={{ position: "relative" }}>
      <Container className="bg-green text-white text-center" style={{ gap: "64px" }}>
        <h2 className="text-center mb-5 section-title">{t("feature-title")}</h2>
        <Row className="justify-content-center">
          {heroData.map((item) => (
            <Col md={6} className="mb-4 d-flex flex-column align-items-center item" key={item.key}>
              <img src={item.img} alt={item.alt} className="img-fluid" />
              <div className="subsection-title" style={{ fontSize: "24px", marginTop: "1.5rem" }}>
                {t(item.key)}
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default StoryFeature;
